/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  currencyValueFormatter,
  interpolateI18n,
} from '@cinch-labs/shared-util'

export const getActiveCtaText = (template: string, budget: number) =>
  interpolateI18n(template, {
    budget: currencyValueFormatter(budget),
  }).join('')

export const getFiltredUrl = (
  baseCtaUrl: string,
  toPrice: number,
  useMonthly: boolean,
) => {
  const parameters = {
    toPrice,
    useMonthly,
    sortingCriteria: useMonthly ? 12 : 10,
  }
  return `${baseCtaUrl}?${Object.entries(parameters)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')}`
}

export const convertToPence = (value: any) => {
  if (value === undefined) return

  if (value === '0') {
    return value
  }

  const onlyNums = Math.round(Number.parseFloat(value.replace(/[^\d.?]/g, '')))

  if (Number.isNaN(onlyNums)) {
    return ''
  }

  return onlyNums * 100
}

export const formatToPounds = (value: string | number | undefined) => {
  if (
    value === undefined ||
    (typeof value === 'string' && Number.isNaN(Number.parseFloat(value)))
  ) {
    return ''
  }

  if (typeof value === 'number') {
    return formatPenceToPounds(value)
  }

  return formatPenceToPounds(Number.parseFloat(value))
}

const formatPenceToPounds = (value: number) => `£${Math.ceil(value / 100)}`
